import React, { createContext, useContext, useState, useEffect } from 'react';
import { useToast } from '@/components/ui/use-toast';

const ComparisonContext = createContext();

export const useComparison = () => {
    return useContext(ComparisonContext);
};

export const ComparisonProvider = ({ children }) => {
    const [comparisonList, setComparisonList] = useState([]);
    const { toast } = useToast();

    useEffect(() => {
        const stored = localStorage.getItem('futura_comparison');
        if (stored) {
            setComparisonList(JSON.parse(stored));
        }
    }, []);

    const addToComparison = (property) => {
        if (comparisonList.length >= 4) {
            toast({
                title: "Límite alcanzado",
                description: "Solo puedes comparar hasta 4 propiedades a la vez.",
                variant: "destructive"
            });
            return;
        }
        if (comparisonList.some(p => p.id === property.id)) return;

        const newList = [...comparisonList, property];
        setComparisonList(newList);
        localStorage.setItem('futura_comparison', JSON.stringify(newList));
        toast({
            title: "Agregado a comparar",
            description: `${property.title} se ha añadido a la comparación.`,
        });
    };

    const removeFromComparison = (propertyId) => {
        const newList = comparisonList.filter(p => p.id !== propertyId);
        setComparisonList(newList);
        localStorage.setItem('futura_comparison', JSON.stringify(newList));
    };

    const isInComparison = (propertyId) => {
        return comparisonList.some(p => p.id === propertyId);
    };

    const toggleComparison = (property) => {
        if (isInComparison(property.id)) {
            removeFromComparison(property.id);
        } else {
            addToComparison(property);
        }
    };

    return (
        <ComparisonContext.Provider value={{ comparisonList, addToComparison, removeFromComparison, isInComparison, toggleComparison }}>
            {children}
        </ComparisonContext.Provider>
    );
};
